import { useEffect, useCallback } from 'react';
import { useNavegate } from 'App/hooks';
import { ACCOUNT_ROUTES } from 'domains/Account/accountRoutes';
import { useAuthenticationFactorDashboardStatus } from 'domains/Account/hooks';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { LOG_EVENTS } from '../CardAuthenticationFactorPromotion';
import { GenericTaskItem } from '../GenericTaskList';

export interface UseAuthenticationFactorPromoteResult {
  item: GenericTaskItem | null;
  handleAction: () => void;
}

function useAuthenticationFactorPromote(): UseAuthenticationFactorPromoteResult {
  const { goTo } = useNavegate();
  const {
    authenticationFactorsDashboardStatus,
    fetchAuthenticationFactorsDashboardStatus,
    status: authFactorStatus,
  } = useAuthenticationFactorDashboardStatus();
  const t = useTranslationDashboard();
  useEffect(() => {
    fetchAuthenticationFactorsDashboardStatus();
  }, [fetchAuthenticationFactorsDashboardStatus]);

  const handleAction = useCallback(() => {
    if (authenticationFactorsDashboardStatus?.bannerToShow) {
      const trackingEvent =
        LOG_EVENTS[authenticationFactorsDashboardStatus.bannerToShow];
      trackingEvent();
      goTo(ACCOUNT_ROUTES.authenticationFactor);
    }
  }, [authenticationFactorsDashboardStatus?.bannerToShow, goTo]);

  const shouldShowRecoveryCodes =
    authFactorStatus === 'success' &&
    authenticationFactorsDashboardStatus &&
    (authenticationFactorsDashboardStatus.bannerToShow ===
      'install_recovery_codes' ||
      authenticationFactorsDashboardStatus.bannerToShow ===
        'last_recovery_codes' ||
      authenticationFactorsDashboardStatus.bannerToShow ===
        'install_authentication_factor');

  const item: GenericTaskItem | null = shouldShowRecoveryCodes
    ? {
        id: 'recovery-codes',
        title: t('authenticationFactors.alertPromote.title'),
        description: t('authenticationFactors.alertPromote.subtitle'),
        iconType: 'lock',
        contentType: 'recommendation',
        actionType: 'recommendation',
      }
    : null;

  return {
    item,
    handleAction,
  };
}

export default useAuthenticationFactorPromote;
